import { render, staticRenderFns } from "./FUniswapSettings.vue?vue&type=template&id=a349ad7e&"
import script from "./FUniswapSettings.vue?vue&type=script&lang=js&"
export * from "./FUniswapSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports